export function toArray(val) {
    val !== null && val !== void 0 ? val : (val = []);
    if (Array.isArray(val))
        return val;
    return [val];
}
